
import "@sparta.home-loans.modules/one-column-content-module/dist/styles.css"
import "@sparta.home-loans.modules/home-equity-engagement-module/dist/styles.css"
import "@sparta.home-loans.modules/headline-mortgage-overview-module/dist/styles.css"
import "@sparta.global.modules/state-selector-module/dist/styles.css"
import "@sparta.home-loans.modules/introductory-rate-module/dist/styles.css"
import "@sparta.home-loans.modules/rates-table-fallback-module/dist/styles.css"
import "@sparta.home-loans.modules/disclosures-toggle-module/dist/styles.css"
import "@sparta.home-loans.modules/interactive-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import jsUtility from "@sparta.home-loans.utilities/js-utility/dist/es6.js"

import "@sparta.home-loans.modules/home-equity-engagement-module/dist/es6.js"
import "@sparta.home-loans.modules/headline-mortgage-overview-module/dist/es6.js"
import "@sparta.global.modules/state-selector-module/dist/es6.js"
import "@sparta.home-loans.modules/introductory-rate-module/dist/es6.js"
import "@sparta.home-loans.modules/rates-table-fallback-module/dist/es6.js"
import "@sparta.home-loans.modules/disclosures-toggle-module/dist/es6.js"
import "@sparta.home-loans.modules/one-column-content-module/dist/es6.js"
import "@sparta.home-loans.modules/interactive-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
secureLinkUtility.run()
  console.log('after - execute boot functions')
})();
